import { render, staticRenderFns } from "./DictTable.vue?vue&type=template&id=273d4462"
import script from "./DictTable.vue?vue&type=script&lang=js"
export * from "./DictTable.vue?vue&type=script&lang=js"
import style0 from "./DictTable.vue?vue&type=style&index=0&id=273d4462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports